import { render, staticRenderFns } from "./message-price.vue?vue&type=template&id=50969099"
import script from "./message-price.vue?vue&type=script&lang=ts"
export * from "./message-price.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports